import { useEffect } from 'react'

export default function useWindowFocus(handleFocus) {
  useEffect(() => {
    window.addEventListener('focus', handleFocus)

    return () => {
      window.removeEventListener('focus', handleFocus)
    }
  }, [handleFocus])
}
